import * as React from 'react'
import type { ElementRef, JSX } from 'react'

import { clsx } from 'clsx'

import { WarningIcon, InfoIcon, CriticalIcon } from '@buffer-mono/popcorn'

import styles from './PostCardNotice.module.css'

const iconByVariant = {
  neutral: InfoIcon,
  info: InfoIcon,
  warning: WarningIcon,
  critical: CriticalIcon,
}

type PostCardNoticeProps = {
  variant: 'neutral' | 'info' | 'critical' | 'warning'
  icon?: React.ReactNode
  children?: React.ReactNode
} & React.HTMLAttributes<HTMLElement>

const PostCardNotice = ({
  variant,
  icon,
  children,
  className,
  ...rest
}: PostCardNoticeProps): JSX.Element => {
  const DefaultIcon = iconByVariant[variant]

  return (
    <section
      className={clsx(styles.notice, styles[variant], className)}
      {...rest}
    >
      <span className={styles.iconSlot}>
        {icon ?? <DefaultIcon aria-hidden />}
      </span>
      {children}
    </section>
  )
}

PostCardNotice.displayName = 'PostCardNotice'

type PostCardNoticeActionProps = {
  children: React.ReactNode
}

const PostCardNoticeAction = React.forwardRef<
  ElementRef<'div'>,
  PostCardNoticeActionProps
>((props, forwardedRef) => {
  return (
    <div className={styles.action} ref={forwardedRef}>
      {props.children}
    </div>
  )
})

PostCardNoticeAction.displayName = 'PostCardNotice.Action'

const PostCardNoticeObject = Object.assign(PostCardNotice, {
  Action: PostCardNoticeAction,
})

export { PostCardNoticeObject as PostCardNotice }
